import { render, staticRenderFns } from "./DivorceCustodyPage.vue?vue&type=template&id=1f3a6038&scoped=true"
import script from "./DivorceCustodyPage.vue?vue&type=script&lang=js"
export * from "./DivorceCustodyPage.vue?vue&type=script&lang=js"
import style0 from "./DivorceCustodyPage.vue?vue&type=style&index=0&id=1f3a6038&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3a6038",
  null
  
)

export default component.exports